import * as React from 'react';
import Icon from '../../components/Icon';
import config from '../../config.json';
import { useState } from 'react';
import { useEffect } from 'react';
import { classNames } from '../../common/css';

const IconButton = ({
    color = config.colors.themeColorCode,
    onClick,
    text,
    className,
    disabled = false,
    name,
    type,
    size = 40
}) => {
    let component = <></>;
    switch (type) {
        case 'play':
            component = <Icon name="play" size={size} color={color} />;
            break;
        case 'edit':
            component = <Icon name="edit" size={size} color={color} />;
            break;
        case 'remove':
            component = <Icon name="trash-icon" size={size} color={color} onClick={onClick} />;
            break;
        case 'chat':
            component = <Icon name="chat" size={size} color={color} />;
            break;
    }

    const [isButtonDisabled, setIsButtonDisabled] = useState(disabled);

    useEffect(() => {
        setIsButtonDisabled(disabled);
    }, [disabled]);

    return (
        <div 
            className={classNames(
                'flex justify-center items-center cursor-pointer rounded-md p-1.5',
                'hover:bg-surface-hover transition-colors duration-150',
                isButtonDisabled && 'opacity-50 cursor-not-allowed',
                className
            )} 
            onClick={() => {
                if (!isButtonDisabled) {
                    onClick(name);
                }
            }}
        >
            {component}
            {text && <span className="ml-1 text-sm">{text}</span>}
        </div>
    );
};

export default IconButton;